module.exports = __webpack_public_path__ + "static/media/sass.a51073c0.svg";